import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TableCell } from '@material-ui/core';

import { UItils } from '@nearst/ui';

import { useIsChain } from '@utils/useIsChain';

import styles from '../../InventoryViewer.module.scss';

const useHandleInventoryClick = () => {
	const navigate = useNavigate();
	const { shopId } = useParams();
	const isChain = useIsChain();
	return (barcode) => {
		if (isChain) {
			navigate(`/inventory/items/${barcode}`);
		} else {
			navigate(`/inventory/${shopId}/items/${barcode}`);
		}
	};
};

const NavigationCell = ({ barcode, className = '', children, ...restOfProps }) => {
	const handleInventoryRowClick = useHandleInventoryClick();

	return (
		<TableCell
			className={UItils.classnames(styles.tableCell, className)}
			onClick={() => handleInventoryRowClick(barcode)}
			{...restOfProps}
		>
			{children}
		</TableCell>
	);
};

export { NavigationCell, useHandleInventoryClick };
